import { useEffect } from 'react';
import Promotion from './promotion';
import dayjs from 'dayjs';
import { usePromotionStore } from 'pages/facilityGroup/useBonusProgramStore';
import { useObject } from 'utils/api/useObject';
import { FacilityBonus } from './form';

import Plus from 'assets/icons/plus';
import { ObjectPromotionRewardTypeEnum, ObjectPromotionRepeatConditionEnum } from '../../../../generated/graphql';

const PromotionBlock = () => {
  const { object } = useObject();
  const promotions = usePromotionStore(state => state.promotions);
  const setPromotions = usePromotionStore(state => state.setPromotions);
  const addPromotions = usePromotionStore(state => state.addPromotions);

  useEffect(() => {
    if (!object?.promotions) return;

    const mappedPromotions: FacilityBonus[] = object.promotions.map((el: any) => ({
      ...el,
      dateFrom: el.startDatetime ? dayjs(el.startDatetime) : null,
      timeFrom: el.startDatetime ? dayjs(el.startDatetime) : null,
      dateTo: el.endDatetime ? dayjs(el.endDatetime) : null,
      timeTo: el.endDatetime ? dayjs(el.endDatetime) : null,
      endless: !el.endDatetime,
    }));

    setPromotions(mappedPromotions);
  }, [object?.promotions, setPromotions]);

  useEffect(() => {
    return () => {
      setPromotions([]);
    };
  }, [setPromotions]);

  const handleCreateNewPromotion = () => {
    const draft: FacilityBonus = {
      id: '',
      name: '',
      status: 'Blank' as any,
      requirementShiftCount: 1,
      rewardType: ObjectPromotionRewardTypeEnum.BonusForGoodShifts,
      rewardSum: 0,
      badShiftCount: 0,
      repeatCondition: ObjectPromotionRepeatConditionEnum.OneTime,
      dateFrom: null,
      timeFrom: null,
      dateTo: null,
      timeTo: null,
      endless: false,
      createdAt: new Date().toISOString(),
      startDatetime: null,
    };
    addPromotions([draft]);
  };

  return (
    <div className="col-span-full xl:col-span-9 md:col-span-7">
      <div className="facilityPageBlock blockTemplate">
        <div className="grid grid-cols-6 gap-y-6">
          <span className="blockTitleTemplate col-span-full">Управление бонусными программами</span>
          <p className={'Body1 text-smena_text-secondary col-span-full'}>
            Настройка бонусных программ здесь повлияет на бонусные программы всех объектов этой группы. Исключение:
            бонусы, которые были созданы или изменены непосредственно на объекте.
          </p>
          <div className="col-span-full">
            <button
              type="button"
              onClick={handleCreateNewPromotion}
              className="w-full flex justify-center items-center gap-x-2 py-5 border-2 border-dashed border-primary/20 rounded-lg bg-transparent text-primary font-semibold text-lg hover:bg-primary/5 transition-colors"
              style={{ marginTop: 8, marginBottom: 8 }}
            >
              <Plus className="text-primary" />
              <span className="text-primary">Добавить бонусную программу</span>
            </button>
          </div>
          {promotions.map(el => (
            <Promotion key={el.id} el={el} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromotionBlock;
